export default class UserModel {
    constructor(data) {
      this.data = data
    }
  
    name() {
      return this.data.firstname + ' ' + this.data.lastname
    }
  
  }


// WEBPACK FOOTER //
// ./src/models/user.js